const SettingsView = () => {
  return <div>SettingsView</div>;
};

export default SettingsView;
